<template>
  <section>
    <div class="container">
      <div class="head">
        <img src="@/assets/back.png" style="margin: 10px" alt="返回" width="21" height="21" @click="go">
        <div>提现</div>
        <div style="margin-right: 10px;color: #FE003B" @click="detail">提现明细</div>
      </div>
      <div class="content">
        <div class="choose">提现到微信钱包</div>
        <div class="allwi">
          <div>提现金额</div>
          <span class="hintwi">（提现金额为100的整数倍）</span>
        </div>
        <div class="money">
          <span class="money-icon">￥</span>
          <input type="text" v-model="form.money" class="input" maxlength="10" onkeyup="this.value=this.value.replace(/[^\d]/g,'')">
          <!--<van-field v-model="form.money" placeholder="请输入提现金额" type="number" clearable/>-->
        </div>
        <div class="allea">
          <div>可提现收益金额为{{user.income}}元，</div>
          <span class="all" @click="cashAll">全部提现</span>
        </div>
        <div class="eahint">高级VIP创客最高提现200元/次/天，3-7工作日到账</div>
      </div>
      <div class="submit-active" v-if="user.income < 100">提现</div>
      <div class="submit" v-else @click="submit">提现</div>
    </div>

  </section>
</template>

<script>
  import { saveShopCash } from '@/api/mine/cash.js'
  import { getCurtUser } from '@/api/login/index.js'
  export default {
    name: "withdraw",
    data() {
      return {
        active: '0',
        user : null,
        form: {
          money: '',
          openId: '',
          uid : '',
          username : '',
          type : 0, //提现渠道：{0：微信，1支付宝}
        }
      }
    },
    created(){
      var user = localStorage.getItem('userInfo')
      if (user){
        user = JSON.parse(user)
        this.getCurtUser(user.id)
      }
    },
    methods: {
      getCurtUser(id){
        getCurtUser({id: id}).then(res=>{
          if (res.success) {
            this.user = res.data
          }
        })
      },
      cashAll () {
        if (this.user.income == 0) {
          this.$toast.fail('余额不足')
          return
        }
        this.form.money = this.user.income
      },
      submit(){
        if (!localStorage.getItem("openid")) {
          this.$toast.fail('openid不存在')
          return
        }
        if (this.user.isvip != 2) {
          this.$toast.fail('只能成为高级VIP创客才能提现哦')
          setTimeout(()=> {
            this.$router.push({
              path:'/mine/vip/interests'
            })
          },2500)
          return
        }
        if (parseInt(this.form.money) > this.user.income) {
          this.$toast.fail('余额不足')
          return
        }
        if (parseInt(this.form.money) < 100) {
          this.$toast.fail('金额要满100才能提现哦')
          return
        } else if ((parseInt(this.form.money)) % 100 != 0) {
          this.$toast.fail('只能按100的整数提现')
          return
        }
        this.form.uid = this.user.id
        this.form.username = this.user.name
        this.form.acount = localStorage.getItem("openid")
        saveShopCash(this.form).then(res => {
          if (res.success) {
            this.$toast.success('提现请求已提交，等待平台管理员审核')
          }else{
            this.$toast.fail(res.msg)
          }
        })
      },
      detail(){
        this.$router.push("/cashDetail")
      },
      go(){
        this.$router.go(-1);
      },
    }
  }
</script>

<style lang="scss" scoped>
  .input{
    width:100%;
    height:40px;
    border-radius:4px;
    padding: 10px;
    font-size: 30px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 42px;
    color: #333333;
  }
  .container{
    .head{
      background-color: #F3F3F3;
      height:44px;
      line-height: 44px;
      opacity:1;
      display: flex;
      justify-content: space-between;
    }
    .content{
      padding: 12px;
      .rehint{
        padding: 22px;
        height:18px;
        font-size:13px;
        font-family:PingFang SC;
        font-weight:400;
        line-height:18px;
        color:rgba(255,255,255,1);
        opacity:1;
      }
      .reprice{
        padding: 22px;
        height:40px;
        font-size:33px;
        font-family:DIN;
        font-weight:bold;
        line-height:40px;
        color:rgba(255,255,255,1);
        opacity:1;
      }
      .choose{
        width: 100%;
        height:20px;
        font-size:14px;
        font-family:PingFang SC;
        font-weight:400;
        line-height:20px;
        color:rgba(51,51,51,1);
        opacity:1;
        text-align: center;
        padding: 22px;
      }
      .allwi{
        display: flex;
        font-size:14px;
        font-family:PingFang SC;
        font-weight:400;
        line-height:20px;
        color:rgba(51,51,51,1);
        opacity:1;
        margin-top: 48px;
        margin-bottom: 34px;
        .hintwi{
          font-size:12px;
          font-family:PingFang SC;
          font-weight:400;
          line-height:17px;
          color:rgba(254,0,59,1);
          opacity:1;
        }
      }
      .allea{
        display: flex;
        font-size:14px;
        font-family:PingFang SC;
        font-weight:400;
        line-height:20px;
        opacity:1;
        margin-top: 6px;
        .all{
          font-size:16px;
          color: #0DC92C;
        }
      }
      .eahint{
        font-size:12px;
        font-family:PingFang SC;
        font-weight:400;
        line-height:17px;
        color:rgba(254,0,59,1);
        opacity:1;
        margin-top: 6px;
        margin-bottom: 70px;
      }
      .money-icon{
        width: 30px;
        height: 42px;
        font-size: 30px;
        font-family: PingFang SC;
        font-weight: bold;
        line-height: 42px;
        color: #333333;
        opacity: 1;

      }
      .money{
        display: flex;
        margin-top: 20px;
        font-weight: bold;
        border-bottom: 1px solid #ebedf0;
        padding: 5px;
      }
    }
  }
  .submit-active{
    height:40px;
    width: 95%;
    background: #C7C7C7;
    opacity:1;
    border-radius:4px;
    color: #ffffff;
    margin: auto;
    text-align: center;
    line-height: 40px;
  }
  .submit{
    height:40px;
    width: 95%;
    background:linear-gradient(0deg,rgba(244,4,66,1) 0%,rgba(226,23,75,0.73) 100%);
    opacity:1;
    border-radius:4px;
    color: #ffffff;
    margin: auto;
    text-align: center;
    line-height: 40px;
  }

</style>



// WEBPACK FOOTER //
// src/views/mine/withdraw.vue